import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Share2, Package, Boxes } from "lucide-react";
import api, { money } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { toast } from "sonner";

export default function LotDetail() {
  const { lotName } = useParams();
  const decoded = decodeURIComponent(lotName || "");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products", { params: { lot: decoded } }).then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [decoded]);

  const share = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) await navigator.share({ title: `Lot ${decoded} · STR Surplus`, url });
      else { await navigator.clipboard.writeText(url); toast.success("Lot link copied to clipboard"); }
    } catch (e) { /* cancelled */ }
  };

  const units = products.reduce((s, p) => s + p.quantity, 0);
  const value = products.reduce((s, p) => s + p.our_price * p.quantity, 0);

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8">
      <Link to="/lots" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-subtle hover:text-ink mb-6"><ArrowLeft className="h-4 w-4" /> All lots</Link>

      <div className="bg-ink text-paper p-6 sm:p-8 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-discount">Auction Lot</div>
          <h1 className="font-heading font-black text-3xl sm:text-5xl tracking-tighter mt-1" data-testid="lot-title">{decoded}</h1>
          <div className="flex gap-6 mt-4 font-mono text-xs">
            <span className="flex items-center gap-1"><Package className="h-4 w-4" /> {products.length} SKUs</span>
            <span className="flex items-center gap-1"><Boxes className="h-4 w-4" /> {units} units</span>
            <span>Inventory value {money(value)}</span>
          </div>
        </div>
        <button data-testid="lot-share-button" onClick={share} className="flex items-center gap-2 bg-paper text-ink px-4 h-10 font-mono text-xs uppercase tracking-wider hover:bg-discount transition-colors self-start">
          <Share2 className="h-4 w-4" /> Share Lot
        </button>
      </div>

      <div className="mt-8">
        {loading ? (
          <div className="font-mono text-subtle">Loading…</div>
        ) : products.length === 0 ? (
          <div className="border border-dashed border-subtle p-12 text-center font-mono text-sm text-subtle">This lot has no products (they may be sold out).</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
